module.exports = __webpack_public_path__ + "img/Kd.37cf8058.png";